import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import 'remixicon/fonts/remixicon.css';
import './tiptap.css';

const MenuBar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="menuBar">
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={editor.isActive('bold') ? 'is-active' : ''}
        title="Bold"
      >
        <i className="ri-bold"></i>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={editor.isActive('italic') ? 'is-active' : ''}
        title="Italic"
      >
        <i className="ri-italic"></i>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        className={editor.isActive('underline') ? 'is-active' : ''}
        title="Underline"
      >
        <i className="ri-underline"></i>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        className={editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}
        title="Heading 1"
      >
        <i className="ri-h-1"></i>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        className={editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}
        title="Heading 2"
      >
        <i className="ri-h-2"></i>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={editor.isActive('bulletList') ? 'is-active' : ''}
        title="Bullet List"
      >
        <i className="ri-list-unordered"></i>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={editor.isActive('orderedList') ? 'is-active' : ''}
        title="Ordered List"
      >
        <i className="ri-list-ordered"></i>
      </button>
    </div>
  );
};

const NotesSection = ({ formData, handleChange }) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline
    ],
    content: formData.coin_details || '',
    onUpdate: ({ editor }) => {
      handleChange({
        target: {
          name: 'coin_details',
          value: editor.getHTML()
        }
      });
    }
  });

  useEffect(() => {
    if (editor && formData.coin_details !== editor.getHTML()) {
      editor.commands.setContent(formData.coin_details || '');
    }
  }, [formData.coin_details, editor]);

  if (!editor) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div>
          <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-2">
            Notes
          </label>
          <textarea
            id="notes"
            name="notes"
            rows={7}
            value={formData.notes}
            onChange={handleChange}
            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md resize-y"
          />
        </div>

        <div>
          <label htmlFor="provenance" className="block text-sm font-medium text-gray-700 mb-2">
            Provenance
          </label>
          <textarea
            name="provenance"
            id="provenance"
            rows={7}
            value={formData.provenance || ''}
            onChange={handleChange}
            className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md resize-y"
          />
        </div>

        <div>
          <div className="block text-sm font-medium text-gray-700 mb-2">
            Details
          </div>
          <div className="border border-gray-300 rounded-md">
            <MenuBar editor={editor} />
            <div className="resize-y">
              <EditorContent 
                editor={editor}
                className="min-h-[106px]"
                aria-label="Details"
              />
            </div>
          </div>
        </div>
      </div>
  );
};

export default NotesSection;
